// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getPreviousBreakpoint from "@toolkit/Framework/Common/Utilities/getPreviousBreakpoint";
import { focusStyles, iconColorStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

export const headerMobileSelector = () => css`
    ${({ theme }) => breakpoint(getPreviousBreakpoint(theme.design.header.breakpoint, theme), "down")}
`;

export const headerDesktopSelector = () => css`
    ${({ theme }) => breakpoint(theme.design.header.breakpoint)}
`;

export const headerHideForDesktopStyles = () => css`
    ${headerDesktopSelector()} {
        display: none;
    }
`;

export const headerHideForMobileStyles = () => css`
    ${headerMobileSelector()} {
        display: none;
    }
`;

export const headerIconStyles = () => {
    const transition = transitionHoverStyles("color");

    /* Store Custom Code - Start */
    return css`
        ${focusStyles(true)}
        ${x => breakpointValues(x.theme.design.header.iconButton.padding, "padding")}
        transition: ${transition};

        > ${IconWrapper} {
            ${iconColorStyles("secondary", transition)}
            ${breakpoint("md")} {
                justify-content: center;
                ${iconColorStyles("white", transition)}
                background: ${getColor("header.accent")};
                width: ${pxToRem(40)};
                height: ${pxToRem(40)};
                border-radius: 100%;

                svg {
                    margin: 0 auto;
                    height: ${pxToRem(22)};
                }
            }
        }

        &:hover,
        &:active,
        &[aria-expanded="true"] {
            ${iconColorStyles("secondary.dark", transition)}
            ${breakpoint("md")} {
                > ${IconWrapper} {
                    background: ${getColor("header.accentHover")};
                    ${iconColorStyles("white", transition)}
                }
            }
        }
    `;
    /* Store Custom Code - End */
};
